/** `/c/$companyId/banking/movements?tab&accountId&kind&from&to&q` — the bank movements list. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MOVEMENT_KINDS, MOVEMENT_LIST_TABS } from "../api/codes";
import { MovementsList } from "../banking/movement/MovementsList";
import { CODE_SETS } from "../ledger/books";
import { CodeGate } from "../shell/CodeGate";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const search = z.object({
  tab: z.enum(MOVEMENT_LIST_TABS).optional().catch(undefined),
  accountId: z.string().uuid().optional().catch(undefined),
  kind: z.enum(MOVEMENT_KINDS).optional().catch(undefined),
  from: isoDate.optional().catch(undefined),
  to: isoDate.optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/banking/movements/")({
  validateSearch: (raw) => search.parse(raw),
  component: MovementsRoute,
});

function MovementsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.MOVE}>
      <MovementsList
        companyId={companyId}
        search={search}
        onSearch={(next) => void navigate({ search: next, replace: true })}
      />
    </CodeGate>
  );
}
